import Routes from "router/routes";
import { Articles } from "features/landing/data/models/article";
import { useNavigate } from "react-router-dom";

const FundraiserBlogCard = ({ article }: { article: Articles }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-2 cursor-pointer hover:scale-105 transition-all duration-300" onClick={() => navigate(Routes.FUNDRAISER_BLOG_DETAILS(article.slug))}>
      <img
        src={`${process.env.REACT_APP_STRAPI_URL}${article.cover?.url}`}
        alt={article.title}
        className="w-full h-[222px] object-cover rounded-[8px]"
      />
      <div className="flex flex-col gap-2 mt-[24px]">
        <p className="font-inter text-[20px] font-semibold leading-[100%] tracking-[-1.5%] text-strong-950">{article.title}</p>
        <p className="font-inter text-[16px] font-normal leading-[22px] tracking-[-1.5%] text-neutral-700">{article.description}</p>
      </div>
    </div>
  );
};

export default FundraiserBlogCard;